import { Component, OnInit, ViewChild } from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { DataCdtService } from "../data-cdt.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TokenService } from "src/app/core/services/token.service";
import { TranslateService } from "@ngx-translate/core";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { Options } from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-list-data-cdt",
  templateUrl: "./list-data-cdt.component.html",
  styleUrls: ["./list-data-cdt.component.sass"],
})
export class ListDataCdtComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  public datasCDTList: any[];
  public filtersTable: string;
  filtersTableJSON;
  public filtersSearch = "";
  filterList = FilterConstants.dataCDT;
  tableList = TableConstants.dataCDT;
  routing = RoutingConstants.dataCDTRouting;
  options: Options = TableConstants.NotShowDeleteAndArrowUpDown;
  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  constructor(
    private dataCdtService: DataCdtService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private translateService: TranslateService,
    private sweetAlertService: SweetAlertService,
    private tokenService: TokenService,
    private commonService: CommonService
  ) {
    this.options.style = { "min-width": "850px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admDatos.datosCDT
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }

  ngOnInit(): void {
    this.loadDataCDTList();
  }

  loadDataCDTList(): void {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.sweetAlertService.sweetAlertLoading();
    this.dataCdtService.list(filters).subscribe(
      (data) => {
        this.datasCDTList = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  filterSearch(value: string) {
    this.filtersSearch = value;
    this.filtersTableStateService.setPageState(0);
    this.filtersTableJSON =
      this.filtersTableStateService.getFiltersTableState();
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.loadDataCDTList();
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadDataCDTList();
  }

  private concatFilters(): string {
    if (this.filtersSearch === "") {
      return "?" + this.filtersTable;
    } else {
      return "?" + this.filtersSearch + "&" + this.filtersTable;
    }
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersValuesSearch = [];
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadDataCDTList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
